import React from 'react';
import Gallery from 'components/image-gallery';
import { observer } from 'mobx-react';

import ContentGate from 'components/content-gate';

import '../../prescriptionInfoBlockStyles.scss';

const ContainerPreLabelImages = ({
  containerImagesFetched,
  postLabelGallery = [],
}) => (
  <div className='c-PrescriptionInfoBlock'>
    <div className='title'>
        Labelled Container Images
    </div>
    <ContentGate
      active={!containerImagesFetched}
      fadeDuration={500}
      color='none'
    >
      {
        postLabelGallery.length
          ? <Gallery
            enableImageSelection={false}
            images={postLabelGallery}
          />
          : <div className='no-data-available'>No labelled images available.</div>
      }
    </ContentGate>
  </div>
);

export default observer(ContainerPreLabelImages);
